// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-faq-by-category-template-js": () => import("./../src/templates/faqByCategoryTemplate.js" /* webpackChunkName: "component---src-templates-faq-by-category-template-js" */),
  "component---src-templates-template-home-js": () => import("./../src/templates/templateHome.js" /* webpackChunkName: "component---src-templates-template-home-js" */),
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

